import { VStack } from "@chakra-ui/react";
import { FeedCardBars } from "src/components/feed-card/content-blocks/bars/feed-card-bars";
import { FeedCardText } from "src/components/feed-card/content-blocks/text/feed-card-text";
import { TFeedCardStackedBarChartBody } from "src/components/feed-card/types/content";
import { EnumFeedCardBlockType } from "src/components/feed-card/types/enums";

export interface IFeedCardStackedBarChartProps {
    items: TFeedCardStackedBarChartBody;
}

export const FeedCardStackedBarChart = ({ items }: IFeedCardStackedBarChartProps) => (
    <VStack spacing={1} align="left">
        {items.map((item, index) => {
            const type = item.type;
            switch (type) {
                case EnumFeedCardBlockType.Text:
                    return <FeedCardText key={index} value={item.body} />;
                case EnumFeedCardBlockType.Bars:
                    return <FeedCardBars key={index} segments={item.body} />;
                default:
                    return <UnsupportedContentType key={index} type={type} />;
            }
        })}
    </VStack>
);

const UnsupportedContentType = ({}: { type: never }) => null;
